/**
 * 注册路由
 * 2017-12-6
 */
"use strict";
angular.module("forgetPasswordRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("forgetpassword", {
        url: "/forgetpassword",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@forgetpassword": {
                templateUrl: 'header/headerLogin_tpl.html',
                controller: 'headerLoginCtrl'
            },
            "main@forgetpassword": {
                templateUrl: "./login/forgetPassword/forgetPassword_tpl.html",
                controller: "forgetPasswordCtrl"
            }
        }
    }).state("forgetpassword.authentication",{
        url: "/authentication",
        views: {
            "main@forgetpassword": {
                templateUrl: "./login/forgetPassword/authentication/authentication_tpl.html",
                controller: "fauthenticationCtrl"
            }
        }
    }).state("forgetpassword.resetpassword",{
        url: "/resetpassword",
        views: {
            "main@forgetpassword": {
                templateUrl: "./login/forgetPassword/resetPassword/resetPassword_tpl.html",
                controller: "fresetPasswordCtrl"
            }
        }
    }).state("forgetpassword.resetsuccess",{
        url: "/resetsuccess",
        views: {
            "main@forgetpassword": {
                templateUrl: "./login/forgetPassword/resetSuccess/resetSuccess_tpl.html",
                controller: "fresetSuccessCtrl"
            }
        }
    });
}]);
